// Quiz questions data
export const QUESTIONS = [
    {
      id: 1,
      q: "Wie gehst du grundsätzlich mit digitalen Innovationen um?",
      A: "Ich probiere neue Apps früh aus und teile meine Erfahrungen.",
      B: "Ich nutze Neues, wenn es mir klare Vorteile bringt.",
      C: "Ich warte ab, bis sich Trends bewährt haben.",
      D: "Ich bleibe lieber bei Bewährtem; zu viel Neues stresst mich."
    },
    {
      id: 2,
      q: "Welche Art von Nachrichtenkonsum passt am besten zu dir?",
      A: "Qualitätsmedien mit langen Hintergrundstücken und Diskurs.",
      B: "Kuratierte Newsletter/Podcasts und verlässliche Mainstream-Medien.",
      C: "Social-Feeds und Creator-Formate, gerne Kurzvideos.",
      D: "Regionale Gruppen/Foren und klassische TV-/Boulevardportale."
    },
    {
      id: 3,
      q: "Wie wichtig ist dir Datenschutz im Alltag?",
      A: "Sehr wichtig: Privacy-Tools, Einwilligungen lesen, Einstellungen anpassen.",
      B: "Wichtig, aber in Balance mit Komfort; ich passe Settings pragmatisch an.",
      C: "Eher egal – Hauptsache kostenlos und schnell.",
      D: "Ich teile sehr wenig und vermeide viele Social-Media-Angebote."
    },
    {
      id: 4,
      q: "Was entscheidet beim Online-Shopping am ehesten?",
      A: "Qualität, Service, Garantien und bekannte Anbieter.",
      B: "Bestes Preis-Leistungs-Verhältnis, Vergleichsportale helfen.",
      C: "Nachhaltigkeit/Transparenz der Marke ist entscheidend.",
      D: "Deals, Trends und 'Must-haves' – ich lasse mich gern inspirieren."
    },
    {
      id: 5,
      q: "Wofür nutzt du das Netz beruflich am meisten?",
      A: "Networking & Thought Leadership (z. B. Fachbeiträge, LinkedIn etc.).",
      B: "Produktivität/Automationen: Tools optimieren meinen Output.",
      C: "Projekt-/Aktionsarbeit in Communities und Kollaborationsplattformen.",
      D: "Berufliches online ist für mich kaum Thema."
    },
    {
      id: 6,
      q: "Welche Unterhaltung spricht dich online eher an?",
      A: "Arthouse, Dokus, Longform-Journalismus.",
      B: "Mainstream-Streaming und Serien mit Freundeskreis.",
      C: "Gaming, Challenges, Memes, Kurzvideos.",
      D: "Klassisches TV/Radio und Mediatheken."
    },
    {
      id: 7,
      q: "Wie verhältst du dich zum Thema Nachhaltigkeit online?",
      A: "Ich informiere mich tief und unterstütze Projekte/Initiativen online.",
      B: "Ich bin dafür – solange es pragmatisch und bezahlbar bleibt.",
      C: "Wichtig, aber online nicht mein Thema.",
      D: "Egal – Hauptsache Spaß und günstig."
    },
    {
      id: 8,
      q: "Wie agierst du in sozialen Netzwerken?",
      A: "Ich diskutiere sachlich und fundiert, auch längere Beiträge.",
      B: "Ich kuratiere & teile, poste selten selbst.",
      C: "Ich poste kreativ/spielerisch und experimentiere.",
      D: "Ich vermeide öffentliche Debatten und halte mich zurück."
    },
    {
      id: 9,
      q: "Finanz- und Behördendinge erledigst du…",
      A: "Digital first: effizient und sicher, gern mit 2FA & Apps.",
      B: "Über offizielle Portale – mit Schritt-für-Schritt-Anleitungen.",
      C: "Wenn möglich offline; online ist mir oft zu kompliziert.",
      D: "Digital – vor allem, wenn es Boni/Rewards gibt."
    },
    {
      id: 10,
      q: "Was zeigst du am ehesten von dir online?",
      A: "Leistung, Erfolg, Effizienz.",
      B: "Werte, Wissen, Kultur.",
      C: "Lifestyle & Spaß.",
      D: "Familie, Verein, Heimat."
    },
    {
      id: 11,
      q: "Wie blickst du auf gesellschaftlichen Wandel im Digitalen?",
      A: "Ich will Wandel aktiv mitgestalten, bin gern Beta-Tester/in.",
      B: "Ich begleite Wandel kritisch mit Argumenten & Fakten.",
      C: "Wandel ist gut – in Dosierung; Stabilität bleibt wichtig.",
      D: "Wandel überfordert, ich mache erstmal nur das Nötigste."
    },
    {
      id: 12,
      q: "Geld & Konsum im Netz:",
      A: "Ich investiere in Premium & Langlebigkeit.",
      B: "Fair & nachhaltig statt billig.",
      C: "Smart sparen mit Coupons & Preisalarmen.",
      D: "Spontan kaufen – der Spaßfaktor zählt."
    }
  ];
  
  // Milieus data
  export const MILIEUS = {
    KG: { name: "Konservativ‑Gehoben", brief: "Nutzen‑ und sicherheitsorientiert; Qualität vor Hype; bevorzugt seriöse Umfelder." },
    PM: { name: "Postmateriell", brief: "Werte‑ & faktenorientiert; Tiefgang, Diskurs und Quellen wichtig." },
    PF: { name: "Performer", brief: "Effizienz & Leistung; setzt auf Tools, Integrationen und klare Time‑Saved‑Benefits." },
    EX: { name: "Expeditiv", brief: "Avantgardistisch & creator‑affin; testet gerne Neues und experimentiert." },
    NEO: { name: "Neo‑Ökologisch", brief: "Nachhaltigkeit & Transparenz; Impact‑Fokus und kollaborative Plattformen." },
    APM: { name: "Adaptiv‑Pragmatische Mitte", brief: "Praktisch & risikoarm; Preis‑/Nutzen, Bewertungen und Support zählen." },
    NB: { name: "Nostalgisch‑Bürgerlich", brief: "Bewährt & überschaubar; einfache Journeys und klassische Medien." },
    TR: { name: "Traditionell", brief: "Ordnung & Vorsicht; wenig öffentliche Selbstdarstellung; Offline‑Optionen hilfreich." },
    PR: { name: "Prekär", brief: "Alltag & Preis im Fokus; niedrige Hürden, klare Hilfe, einfache Zahlarten." },
    KH: { name: "Konsum‑Hedonistisch", brief: "Spaß & Trends; Social Commerce, schnelle CTAs, Rewards/Deals." }
  };
  
  // Cluster mapping with descriptions
  export const CLUSTERS = {
    "Sicherheit & Ordnung": {
      milieus: ["Nostalgisch‑Bürgerlich", "Traditionell"],
      description: "Wertschätzung von Stabilität, bewährten Strukturen und traditionellen Werten. Fokus auf Sicherheit und Ordnung im digitalen Alltag."
    },
    "Status & Etablierung": {
      milieus: ["Konservativ‑Gehoben"],
      description: "Qualitätsbewusstsein und seriöse, etablierte Lösungen. Bevorzugung von bewährten, hochwertigen digitalen Angeboten."
    },
    "Leistung & Selbstoptimierung": {
      milieus: ["Performer", "Expeditiv", "Adaptiv‑Pragmatische Mitte"],
      description: "Fokus auf Effizienz, Innovation und persönliche Weiterentwicklung. Nutzung digitaler Tools zur Optimierung und des Experimentierens."
    },
    "Sinn & Verantwortung": {
      milieus: ["Neo‑Ökologisch", "Postmateriell"],
      description: "Werteorientierung, Nachhaltigkeit und gesellschaftliche Verantwortung. Tiefe Auseinandersetzung mit digitalen Themen und deren Auswirkungen."
    },
    "Spaß & Erlebnis": {
      milieus: ["Konsum‑Hedonistisch"],
      description: "Freude an Unterhaltung, Trends und sozialen Erlebnissen. Digitale Plattformen als Quelle für Spaß und Inspiration."
    },
    "Preis & Entlastung": {
      milieus: ["Prekär"],
      description: "Pragmatischer Umgang mit begrenzten Ressourcen. Fokus auf kostenlose oder günstige digitale Lösungen für den Alltag."
    }
  };
  
  // Scoring matrix (+3/+2/+1/0) - BALANCED for fairness with content consistency
  // Distribution: 
  //   - Benachteiligte Milieus (PF, EX, NEO, PR) erhalten +3 Scores für Fairness
  //   - Andere Milieus erhalten +2 Scores
  //   - Max 16-18 Punkte pro Milieu
  // This ensures EVERY milieu can theoretically win while maintaining content consistency
  export const SCORING = {
    // Q1: Digital innovations - EX, APM, NB, TR (EX +3 für Fairness)
    1: { A: { EX: 3, PF: 1, KH: 1 }, B: { APM: 2, PF: 1, KG: 1 }, C: { NB: 2, TR: 1, KG: 1, EX: 1 }, D: { TR: 2, PR: 1, NB: 1 } },
    // Q2: News consumption - PM, APM, KH, NB (APM für inhaltliche Konsistenz)
    2: { A: { PM: 2, KG: 1, NEO: 1 }, B: { APM: 2, PM: 1, PF: 1, KG: 1 }, C: { KH: 2, EX: 1, PR: 1 }, D: { NB: 2, TR: 1, PR: 1 } },
    // Q3: Privacy importance - KG, APM, PR, TR (PR +3 für Fairness)
    3: { A: { KG: 2, PM: 1, TR: 1 }, B: { APM: 2, KG: 1, PM: 1, NEO: 1 }, C: { PR: 3, KH: 1, EX: 1 }, D: { TR: 2, NB: 1, PR: 1 } },
    // Q4: Online shopping - KG, APM, NEO, KH (NEO +3 für Fairness)
    4: { A: { KG: 2, PM: 1 }, B: { APM: 2, NB: 1, PF: 1 }, C: { NEO: 3, PM: 1, EX: 1, PF: 1 }, D: { KH: 2, EX: 1, PR: 1 } },
    // Q5: Professional use - PF, PF, NEO, PR (PF +3 für Fairness)
    5: { A: { PF: 3, KG: 1, EX: 1 }, B: { PF: 3, APM: 1, NEO: 1 }, C: { NEO: 2, PM: 1, EX: 1, PF: 1 }, D: { PR: 2, TR: 1, NB: 1 } },
    // Q6: Entertainment - PM, NB, KH, TR (PM für inhaltliche Konsistenz)
    6: { A: { PM: 2, NEO: 1, PF: 1 }, B: { NB: 2, APM: 1, TR: 1 }, C: { KH: 2, EX: 1, PR: 1 }, D: { TR: 2, NB: 1 } },
    // Q7: Sustainability - NEO, APM, TR, KH (NEO +3 für Fairness)
    7: { A: { NEO: 3, PM: 1, PF: 1 }, B: { APM: 2, NB: 1 }, C: { TR: 2, NB: 1, KG: 1 }, D: { KH: 2, PR: 1, EX: 1 } },
    // Q8: Social networks - PM, KG, EX, TR
    8: { A: { PM: 2, KG: 1, NEO: 1 }, B: { KG: 2, APM: 1 }, C: { EX: 2, KH: 1, PF: 1, NEO: 1 }, D: { TR: 2, NB: 1, PR: 1 } },
    // Q9: Finance/Government - PF, APM, TR, KH (PF +3 für Fairness)
    9: { A: { PF: 3, KG: 1, PM: 1 }, B: { APM: 2, NB: 1 }, C: { TR: 2, PR: 1 }, D: { KH: 2, PR: 1, EX: 1 } },
    // Q10: Online self-presentation - PF, PM, KH, NB (PF +3 für Fairness)
    10: { A: { PF: 3, KG: 1, EX: 1 }, B: { PM: 2, NEO: 1, PF: 1 }, C: { KH: 2, EX: 1, NEO: 1 }, D: { NB: 2, TR: 1, PR: 1 } },
    // Q11: Digital change - EX, PM, KG, PR (EX +3, PR +3 für Fairness)
    11: { A: { EX: 3, PF: 1 }, B: { PM: 2, NEO: 1, PF: 1, APM: 1 }, C: { KG: 2, NB: 1 }, D: { PR: 3, TR: 1 } },
    // Q12: Money & consumption - KG, NEO, APM, KH (NEO +3 für Fairness)
    12: { A: { KG: 2, PF: 1 }, B: { NEO: 3, PM: 1, PF: 1, APM: 1 }, C: { APM: 2, PR: 1, NB: 1 }, D: { KH: 2, PR: 1, EX: 1 } }
  };
  